import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('../components/Index.vue'),
      meta: {
        title: '测试页面'
      }
    }, 
    {
      path: '/contect',
      name: 'contect',
      component: () => import('../components/Contect.vue'),
    },
    {
      path: '/start',
      name: 'start',
      component: () => import('../components/Start.vue'),
      meta: {
        title: '快速体验'
      }
    },
    {
      path: '/component',
      name: 'component',
      component: () => import('../components/ComponentsMain.vue'),
      redirect: '/component/guide',
      meta: {
        title: '开发文档'
      },
      children: [
        {
          path: '/component/guide',
          name: 'guide',
          component: r => require.ensure([], () => r(require('../docs/guide.md'))),
          meta: {
            title: '开发指南'
          }
        },
        {
          path: '/component/log',
          name: 'log',
          component: r => require.ensure([], () => r(require('../docs/log.md'))),
          meta: {
            title: '更新日志'
          }
        },
        {
          path: '/component/riceIndex',
          name: 'riceIndex',
          component: r => require.ensure([], () => r(require('../docs/rice_index.md'))),
          meta: {
            title: '首屏组件'
          }
        },
        {
          path: '/component/ricePreviewBridge',
          name: 'ricePreviewBridge',
          component: r => require.ensure([], () => r(require('../docs/rice_preview_bridge.md'))),
          meta: {
            title: '表单动态渲染'
          }
        },
        {
          path: '/component/ricePreviewForm',
          name: 'ricePreviewForm',
          component: r => require.ensure([], () => r(require('../docs/rice_preview_form.md'))),
          meta: {
            title: '表单预览'
          }
        },
        {
          path: '/component/ricePreviewRender',
          name: 'ricePreviewRender',
          component: r => require.ensure([], () => r(require('../docs/rice_preview_render.md'))),
          meta: {
            title: '渲染预览'
          }
        },
        {
          path: '/component/test',
          name: 'test',
          component: r => require.ensure([], () => r(require('../docs/test.md'))),
          meta: {
            title: '测试数据'
          }
        }
      ]
    },
  ]
})







// WEBPACK FOOTER //
// ./examples/router/index.js